import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '@env';
import { menuOptions } from '../pages/menu/menu.model';

@Injectable({
  providedIn: 'root'
})

export class AuthService {

  private static readonly JWT_SEGMENT_COUNT = 3;
  private static readonly HEX_PADDING = -2;

  endpointUrl = `${environment.domain}/${environment.userManagementPath}menu-options`;

  private userNameSubject = new BehaviorSubject<string | null>(null);
  public allowedMenuOptions: any[] = [];
  public decodedToken = this.decodeJWT(this.getToken());

  constructor(private http: HttpClient) {
    this.updateUserName();
  }

  public updateUserName(): void {
    const token = this.getToken();
    if (token) {
      const username = this.getUsernameFromToken();
      this.userNameSubject.next(username);
    } else {
      this.userNameSubject.next(null);
    }
  }

  getUsernameObservable(): Observable<string | null> {
    return this.userNameSubject.asObservable();
  }

  getUsernameFromToken(): string {
    const decodedToken = this.decodeJWT(this.getToken());
    const usernameWithDomain = decodedToken.preferred_username;
    return usernameWithDomain ? usernameWithDomain.split("@")[0] : "";
  }


  getOptionByIdRole(role: string): Observable<any> {
    return this.http.get<any>(`${this.endpointUrl}/${role}`).pipe();
  }

  public getToken(): string | null {
    let token: string | null = null;

    // revisar en localStorage
    for (let i = 0; i < localStorage.length; i++) {
      const value = localStorage.getItem(localStorage.key(i)!);
      if (value && value.includes("IdToken")) {
        try {
          token = JSON.parse(value).secret;
          return token;
        } catch { }
      }
    }

    // revisar en sessionStorage
    for (let i = 0; i < sessionStorage.length; i++) {
      const value = sessionStorage.getItem(sessionStorage.key(i)!);
      if (value && value.includes("IdToken")) {
        try {
          token = JSON.parse(value).secret;
          return token;
        } catch { }
      }
    }
    return token;
  }


  decodeJWT(token: string | null): any {
    if (token?.split(".").length === AuthService.JWT_SEGMENT_COUNT) {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const payload = decodeURIComponent(
        atob(base64)
          .split("")
          .map((c) => {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(AuthService.HEX_PADDING);
          })
          .join("")
      );

      return JSON.parse(payload);
    } else {
      return null;
    }
  }

  getRoleFromToken(): string | null {
    const decoded = this.decodeJWT(this.getToken());
    if (!decoded) {
      return null;
    }
    if (decoded.role) {
      return decoded.role;
    }
    if (decoded.roles && Array.isArray(decoded.roles)) {
      return decoded.roles[0]; // ejemplo si viene en un array
    }
    if (decoded.realm_access?.roles) {
      return decoded.realm_access.roles[0];
    }
    return null;
  }

  fillAllowMenuOptions() {
    const role = this.getRoleFromToken()||'';
    return new Promise<void>((resolve, reject) => {
      this.getOptionByIdRole(role).subscribe({
        next: (data: any[]) => {
          const allowedCodes = data.map(opt => opt.code?.toString().trim());
          this.allowedMenuOptions = menuOptions.filter(opt =>
            allowedCodes.includes(opt.code.toString().trim())
          );
          console.log("Allowed Menu Options:", this.allowedMenuOptions);

          resolve();

        },
        error: (err) => {
          console.error("❌ Error al consumir servicio:", err);
          reject();
        },
      });
    })
  }


}

